<template>
  <div class="swiper-panel">
  	<swiper :options="swiperOption" ref="mySwiper">
  	  <swiper-slide v-for="(item, index) in lists" :key="index">
  		<div class="swiper-title">
			<img src="../../../assets/img/course/Class2/dui.png" alt="" />
			{{item.title}}
		</div>
  	  </swiper-slide>
  	</swiper>
  </div>
</template>
<script>
export default {
  name: "ltVideoBanner",
  data(){
	  return{
		  lists:[
        {title:'王** 免费领取了《LeetCode千题讲解》课程 '},{title:'金** 免费领取了《LeetCode千题讲解》课程 '},{title:'唐** 免费领取了《LeetCode千题讲解》课程 '},{title:'赵** 免费领取了《LeetCode千题讲解》课程 '},{title:'李** 免费领取了《LeetCode千题讲解》课程 '},{title:'马** 免费领取了《LeetCode千题讲解》课程 '},{title:'李** 免费领取了《LeetCode千题讲解》课程 '},{title:'张** 免费领取了《LeetCode千题讲解》课程 '},{title:'陶** 免费领取了《LeetCode千题讲解》课程 '},{title:'杨** 免费领取了《LeetCode千题讲解》课程 '},{title:'潘** 免费领取了《LeetCode千题讲解》课程 '},{title:'杜** 免费领取了《LeetCode千题讲解》课程 '},{title:'鲁** 免费领取了《LeetCode千题讲解》课程 '},{title:'孙** 免费领取了《LeetCode千题讲解》课程 '},{title:'丰** 免费领取了《LeetCode千题讲解》课程 '},{title:'耿** 免费领取了《LeetCode千题讲解》课程 '},{title:'吴** 免费领取了《LeetCode千题讲解》课程 '},{title:'厉** 免费领取了《LeetCode千题讲解》课程 '},{title:'巴** 免费领取了《LeetCode千题讲解》课程 '},{title:'丁** 免费领取了《LeetCode千题讲解》课程 '},{title:'王** 免费领取了《LeetCode千题讲解》课程 '},{title:'牛** 免费领取了《LeetCode千题讲解》课程 '},{title:'苏** 免费领取了《LeetCode千题讲解》课程 '},{title:'张** 免费领取了《LeetCode千题讲解》课程 '},{title:'赵** 免费领取了《LeetCode千题讲解》课程 '},{title:'郑** 免费领取了《LeetCode千题讲解》课程 '},{title:'钱** 免费领取了《LeetCode千题讲解》课程 '},{title:'安** 免费领取了《LeetCode千题讲解》课程 '},{title:'袁** 免费领取了《LeetCode千题讲解》课程 '},{title:'李** 免费领取了《LeetCode千题讲解》课程 '},{title:'宋** 免费领取了《LeetCode千题讲解》课程 '},{title:'梁** 免费领取了《LeetCode千题讲解》课程 '},{title:'钟** 免费领取了《LeetCode千题讲解》课程 '},{title:'祖** 免费领取了《LeetCode千题讲解》课程 '},{title:'王** 免费领取了《LeetCode千题讲解》课程 '},{title:'陆** 免费领取了《LeetCode千题讲解》课程 '},{title:'江** 免费领取了《LeetCode千题讲解》课程 '},{title:'董** 免费领取了《LeetCode千题讲解》课程 '},{title:'万** 免费领取了《LeetCode千题讲解》课程 '},{title:'徐** 免费领取了《LeetCode千题讲解》课程 '},{title:'胡** 免费领取了《LeetCode千题讲解》课程 '},{title:'叶** 免费领取了《LeetCode千题讲解》课程 '},{title:'朱** 免费领取了《LeetCode千题讲解》课程 '},{title:'秦** 免费领取了《LeetCode千题讲解》课程 '},{title:'陈** 免费领取了《LeetCode千题讲解》课程 '},{title:'任** 免费领取了《LeetCode千题讲解》课程 '},{title:'罗** 免费领取了《LeetCode千题讲解》课程 '},{title:'戴** 免费领取了《LeetCode千题讲解》课程 '},{title:'姚** 免费领取了《LeetCode千题讲解》课程 '},{title:'邵** 免费领取了《LeetCode千题讲解》课程 '}
		  ],
		  swiperOption: {
		    loop: true,
		    direction: "vertical",
		    slidesPerView: 4,
		    observer: true,
		    autoplay: {
		      delay: 1000,
		      stopOnLastSlide: false,
		      disableOnInteraction: false,
		    },
		  },
	  }
  }
};
</script>
<style scoped>
.swiper-title{
	display: flex;
	align-items: center;
	img{
		width: 11px;
	}
}
.flex-col{
	flex: 1;
	min-width: 0;
}
.lt-first{
	padding-top: 50px;
}
.swiper-panel{
	background-color: rgba(255, 255, 255, .2);
	padding:10px 15px;
	border-radius:5px;
	font-size: 13px;
	color: #ffffff;
}
.swiper-panel .swiper-container{
	height: 100px;
	line-height: 20px;
}
.lt-title{
	font-size: 32px;
	font-weight: bold;
	margin-bottom: 20px;
}
.lt-result{
	margin-bottom: 20px;
	.lt-result-item{
		position: relative;
		padding-left: 15px;
	}
	.lt-result-item::before{
		position: absolute;
		left: 0;
		top: 50%;
		margin-top: -3px;
		content: '';
		width: 6px;
		height: 6px;
		background: #FE6E49;
		border-radius: 50%;
	}
}

</style>
